export default __webpack_public_path__ + "static/media/05.f44c6684.jpg";